import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { RouterLink, RouterView } from 'vue-router'

import MenuNavTop from "../src/components/MenuNavTop.vue"
import MenuRight from "../src/components/MenuRight.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

if(localStorage.getItem("status_auth")) {
    const user_id = localStorage.getItem("user_id");
    const status_auth = localStorage.getItem("status_auth");    
    console.log(status_auth)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MenuRight),
    _createVNode(_unref(RouterView))
  ], 64))
}
}

})